import React from "react";
import styles from "./Spinner.module.css";

const Spinner: React.FC<React.SVGProps<SVGSVGElement>> = ({
	width = 18,
	height = 18,
	className,
	...props
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			className={`${styles.spin}${className ? ` ${className}` : ""}`}
			{...props}
		>
			<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
			<path
				d="M12 2a10 10 0 0 1 10 10"
				stroke="currentColor"
				strokeWidth="3"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default Spinner;